<template>
	<div>
		<j-base-input-text v-model="formattedLiquid" class="mb2" />
		<j-base-input-search v-model="searchKey" class="mb2" />

		<div style="height: 500px; overflow-y: scroll;" class="bg5 mb4">
			<j-spinner class="mt4" size="large" v-if="isLoading" />
			<field-item
				v-else
				:fieldsArray="computedQueries"
				:types="types"
				@path:added="handleAdd"
				@path:removed="handleRemove"
			/>
		</div>
		<div class="flex xs-right">
			<j-button @click="confirmSelection">{{ $t("confirm") }}</j-button>
		</div>
	</div>
</template>

<script>
import FieldItem from "./FieldItem"
import JBaseInputSearch from "@/components/JBaseInputSearch/"
import JSpinner from "@/components/JSpinner"
import JButton from "@/components/JButton/"
import JBaseInputText from "@/components/JBaseInputText"

import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"

export default {
	components: {
		FieldItem,
		JBaseInputSearch,
		JSpinner,
		JButton,
		JBaseInputText
	},

	data() {
		return {
			path: [],
			queries: [],
			types: [],
			searchKey: null,
			isLoading: false,
			formattedLiquid: null
		}
	},

	methods: {
		async getIntrospectionFromGraphQl() {
			this.isLoading = true

			const query = gql`
				query IntrospectionQuery {
					__schema {
						queryType {
							name
							description
							fields {
								name
								description
								args {
									...InputValue
								}
								type {
									...TypeRef
								}
							}
						}
						types {
							...FullType
						}
					}
				}

				fragment FullType on __Type {
					kind
					name
					description
					fields(includeDeprecated: true) {
						name
						description
						args {
							...InputValue
						}
						type {
							...TypeRef
						}
						isDeprecated
						deprecationReason
					}
					inputFields {
						...InputValue
					}
					interfaces {
						...TypeRef
					}
					enumValues(includeDeprecated: true) {
						name
						description
						isDeprecated
						deprecationReason
					}
					possibleTypes {
						...TypeRef
					}
				}

				fragment InputValue on __InputValue {
					name
					description
					type {
						...TypeRef
					}
					defaultValue
				}

				fragment TypeRef on __Type {
					kind
					name
					ofType {
						kind
						name
						ofType {
							kind
							name
							ofType {
								kind
								name
								ofType {
									kind
									name
									ofType {
										kind
										name
										ofType {
											kind
											name
											ofType {
												kind
												name
											}
										}
									}
								}
							}
						}
					}
				}
			`
			const variables = {}

			const res = await api({ query, variables })

			this.isLoading = false

			this.queries = res?.data?.__schema?.queryType?.fields
			this.types = res?.data?.__schema?.types
		},

		handleAdd({ payload, modifiers }) {
			this.path.push({ payload, modifiers })
		},
		handleRemove({ payload, modifiers }) {
			const foundIndex = this.path?.findIndex(
				item => item.payload.name === payload.name
			)
			this.path.splice(foundIndex) // remove all items in array after this index
		},
		confirmSelection() {
			this.$emit("data:selected", this.formattedLiquid)
		}
	},

	computed: {
		computedQueries() {
			return this.searchKey === null || this.searchKey === ""
				? this.queries
				: this.queries?.filter(item => item.name.includes(this.searchKey))
		}
	},

	watch: {
		path: {
			handler() {
				const path = this.path
					?.map(item => {
						// type LIST modifiers
						if (item?.modifiers?.hasOwnProperty("index")) {
							return `${item?.payload?.name}[${item?.modifiers?.index}]`
						} else return item?.payload?.name
					})
					?.join(".")
				this.formattedLiquid = `{{- data.${path} -}}`
			},
			immediate: true
		}
	},

	created() {
		this.getIntrospectionFromGraphQl()
	}
}
</script>
